'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _authorisation = _interopRequireDefault(require("./../authorisation"));

require("whatwg-fetch");

var _translate = _interopRequireDefault(require("../translate"));

var _index = _interopRequireDefault(require("../datalist/index"));

var _projectStatus = _interopRequireDefault(require("../project-status"));

var _fetchUtils = _interopRequireDefault(require("../../fetchUtils"));

var _conf = _interopRequireDefault(require("../../conf"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var withAuthorisation = (0, _authorisation.default)(['admin', 'projectresponsible'], ['schub', 'vomhof', 'stallvisite', 'lockpfosten', 'brunch', 'toh'], false);

var UserStatusList = /*#__PURE__*/function (_React$Component) {
  _inherits(UserStatusList, _React$Component);

  function UserStatusList(props) {
    var _this;

    _classCallCheck(this, UserStatusList);

    _this = _possibleConstructorReturn(this, (UserStatusList.__proto__ || Object.getPrototypeOf(UserStatusList)).call(this, props));
    _this.state = {
      isLoading: false,
      projectData: [],
      farmData: []
    };
    _this.farmDetailLink = _this.farmDetailLink.bind(_assertThisInitialized(_this));
    _this.addFarmButton = _this.addFarmButton.bind(_assertThisInitialized(_this));
    _this.createFarm = _this.createFarm.bind(_assertThisInitialized(_this));
    _this.load = _this.load.bind(_assertThisInitialized(_this));
    _this.farmColumns = [{
      title: props.t('farm name'),
      prop: 'farmname'
    }, {
      title: '',
      render: _this.farmDetailLink
    }];
    _this.staticTexts = {
      noData: props.t('no data'),
      loading: props.t('loading data')
    };
    return _this;
  }

  _createClass(UserStatusList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: "load",
    value: function load() {
      var _this2 = this;

      this.setState({
        isLoading: true
      });
      return fetch("/api/".concat(this.props.i18n.language, "/users/").concat(this.props.userId, "/status"), {
        credentials: 'include'
      }).then(_fetchUtils.default.checkStatus).then(function (status) {
        _this2.setState(function (prev) {
          prev.farmData = [];
          var data = {
            farmname: _this2.props.t('no data')
          };

          if (status.farm.id) {
            data = status.farm;
          }

          prev.farmData.push(data);
          return prev;
        });
      }).catch(function (err) {
        void 0;
      }).then(function () {
        _this2.setState({
          isLoading: false
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          t = _this$props.t,
          i18n = _this$props.i18n,
          userId = _this$props.userId,
          history = _this$props.history;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.props.farmAnchorId
      }, t('farm')), /*#__PURE__*/_react.default.createElement(_index.default, {
        withControls: false,
        enableSort: false,
        isLoading: this.state.isLoading,
        keys: ['name'],
        columns: this.farmColumns,
        initialData: this.state.farmData,
        staticTexts: this.staticTexts,
        showAddFarm: true
      }), /*#__PURE__*/_react.default.createElement(_projectStatus.default, {
        userId: userId,
        t: t,
        i18n: i18n,
        history: history,
        anchorId: this.props.projectAnchorId
      }));
    }
  }, {
    key: "farmDetailLink",
    value: function farmDetailLink(val, row) {
      var _this$props2 = this.props,
          t = _this$props2.t,
          history = _this$props2.history;
      var FarmButton = withAuthorisation(this.addFarmButton());
      if (!row.id) return /*#__PURE__*/_react.default.createElement(FarmButton, null);
      return /*#__PURE__*/_react.default.createElement("a", {
        className: "icon-link",
        href: "/farm/".concat(row.id),
        title: t('Edit'),
        onClick: function onClick(e) {
          e.preventDefault();
          history.push("/farm/".concat(row.id));
        }
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: "icon icon-detail"
      }));
    }
  }, {
    key: "addFarmButton",
    value: function addFarmButton() {
      var _this3 = this;

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "add-farm-link"
      }, /*#__PURE__*/_react.default.createElement("button", {
        type: "button",
        onClick: function onClick() {
          return _this3.createFarm();
        },
        className: "btn btn--small center"
      }, this.props.t('Hof anlegen')));
    }
  }, {
    key: "createFarm",
    value: function createFarm() {
      var _this4 = this;

      var uri = _conf.default.api.createFarmFromUserTemplate(this.props.i18n.language, this.props.userId);

      this.setState({
        isLoading: true
      });
      fetch(uri, {
        credentials: 'include',
        method: 'POST'
      }).then(_fetchUtils.default.checkStatus).then(function (response) {
        _this4.props.history.push("/farm/".concat(response.id));
      }).catch(function (err) {
        void 0;

        _this4.setState({
          isLoading: false
        });
      });
    }
  }]);

  return UserStatusList;
}(_react.default.Component);

UserStatusList.defaultProps = {
  farmAnchorId: 'farm-status',
  projectAnchorId: 'project-status'
};
UserStatusList.propTypes = {
  userId: _propTypes.default.number.isRequired,
  history: _propTypes.default.object.isRequired,
  farmAnchorId: _propTypes.default.string,
  projectAnchorId: _propTypes.default.string,
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  t: _propTypes.default.func.isRequired
};

var _default = (0, _translate.default)(UserStatusList);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/user-status/index.js
// module id = 740
// module chunks = 0